import {LOCATION_CHANGE} from 'connected-react-router/esm';

const initialState = {
    navBarOpen: false,
    params: {}, // match params
    initialHash: "", // the initial hash
    currentArticleBeingScrolled: null,
    currentArticleScrollPercentage: 0,
    isPdfDownloading: false, // are we currently downloading a PDF
    isSharingMenuOpen: false, // is the sharing menu open
    isCopying: false, // are we currently copying something
    thingToCopy: null, // what are we currently copying
    progressTracker: null, // the progress tracker timer
};

export default (state = initialState, action) => {
        // Toggle the nav bar on/off (only matters on mobile)
        if(action.type == "navigation/NAV_BAR_TOGGLE") {
            return {
                ...state,
                navBarOpen: action.payload
            };
        } else if(action.type == "navigation/START_PROGRESS_TRACKER") {
            return {
                ...state,
                progressTracker: action.payload
            };
        } else if(action.type == "navigation/UPDATE_SCROLLING_STATS") {
            return {
                ...state,
                currentArticleBeingScrolled: action.payload.currentArticle,
                currentArticleScrollPercentage: action.payload.percentage
            };
        } else if(action.type == "navigation/OPEN_SHARING_MENU") {
            return {
                ...state,
                isSharingMenuOpen: true
            };
        } else if(action.type == "navigation/CLOSE_SHARING_MENU") {
            return {
                ...state,
                isSharingMenuOpen: false
            };
        } else if(action.type == "navigation/TOGGLE_SHARING_MENU") {
            return {
                ...state,
                isSharingMenuOpen: !state.isSharingMenuOpen
            };
        } else if(action.type == "navigation/PDF_START_DOWNLOAD") {
            return {
                ...state,
                isPdfDownloading: true
            };
        } else if(action.type == "navigation/PDF_STOP_DOWNLOAD") {
            return {
                ...state,
                isPdfDownloading: false
            };
        } else if(action.type == "navigation/COPY_TO_CLIPBOARD") {
            return {
                ...state,
                thingToCopy: action.payload.thingToCopy,
                isCopying: true
            };
        } else if(action.type == "navigation/COPY_TO_CLIPBOARD_DONE") {
            return {
                ...state,
                isCopying: false
            };
        } else if(action.type == "navigation/PAGE_LOADED") {
            return {
                ...state,
                params: action.payload.params,
                initialHash: action.payload.initialHash
            };
        }
        return state;
};
